import { isFeatureEnabled } from 'owa-feature-flags';

export type SubstrateSearchEndpoint = 'suggestions' | 'events' | 'init' | 'query' | 'searchHistory';

export default function getSubstrateSearchEndpoint(endpoint: SubstrateSearchEndpoint) {
    const owsPath = isFeatureEnabled('sea-skipOwsPrime') ? '' : 'ows/';

    // This is a quick hack we would like to investigate 3S last mile performance.
    // Normally a client issued a /init call before first /query call to 3S.
    // We noticed the last mile time for first /query call is higher than later /query calls.
    // To improve performance of actual first /query to 3S, we trick browser to issue a /query call
    // and convert this call to /init in OWS'. We use HTTP Method to differentiate /init call
    // and /query call since actual /query is a POST, while /init is a GET.
    // All changes here are for the quick investigation. If our theory is proved, we will remove the hack and use a formal way to implement this feature.
    if (
        endpoint == 'init' &&
        isFeatureEnabled('sea-initAsQuery') &&
        !isFeatureEnabled('sea-skipOwsPrime')
    ) {
        endpoint = 'query';
    }

    return `${owsPath}search/api/v1/${endpoint}`;
}
